import type { AdminCrewReportImportEmailGroupProps } from "../../models/admin-crew-report.models";
import { ADMIN_CREW_REPORT_IMPORT_OUTCOME_CLASSES } from "../../utils/admin-crew-report.constants";
import { twMerge } from "tailwind-merge";

const AdminCrewReportImportEmailGroup = ({ items }: AdminCrewReportImportEmailGroupProps) => {
  const email = items[0];
  if (!email) return null;

  return (
    <article className="admin-crew-report-import-print-email border border-[#D8E6E3] bg-white dark:border-gray-700 dark:bg-gray-800">
      <header className="grid gap-1 bg-[#F1FAF8] px-4 py-3 text-sm dark:bg-teal-950/30">
        <div className="font-semibold">{email.subject || "No subject"}</div>
        <div className="break-all text-xs text-[#596563] dark:text-gray-300">From: {email.sender}</div>
        <div className="break-all text-xs text-[#596563] dark:text-gray-300">
          Received: <time dateTime={email.receivedAt}>{email.receivedAt}</time>
        </div>
        <div className="break-all text-xs text-[#596563] dark:text-gray-300">Graph message ID: {email.messageId}</div>
      </header>

      <div className="divide-y divide-[#E5EEEC] dark:divide-gray-700">
        {items.map((item) => (
          <section key={`${item.messageId}-${item.attachmentId}`} className="grid gap-2 px-4 py-3 text-sm">
            <div className="flex flex-wrap items-center justify-between gap-2">
              <div className="min-w-0 break-all font-semibold">{item.attachmentName}</div>
              <span
                className={twMerge(
                  "inline-flex flex-none px-2 py-1 text-[11px] font-bold uppercase tracking-wide",
                  ADMIN_CREW_REPORT_IMPORT_OUTCOME_CLASSES[item.outcome],
                )}
              >
                {item.outcome.replace(/_/g, " ")}
              </span>
            </div>
            <div className="flex flex-wrap gap-x-5 gap-y-1 text-xs text-[#596563] dark:text-gray-300">
              <span>IMO: {item.imoNumber ?? "Not resolved"}</span>
              <span>Authentication: {item.authenticationMethod?.replace(/_/g, " ") ?? "Not established"}</span>
              <span>Imported rows: {item.importedRowCount ?? 0}</span>
            </div>
            {item.reasons.length > 0 && (
              <ul className="grid list-disc gap-1 pl-5 text-xs leading-5 text-[#7A2728] dark:text-red-200">
                {item.reasons.map((reason, index) => (
                  <li key={`${item.attachmentId}-reason-${index}`}>{reason}</li>
                ))}
              </ul>
            )}
          </section>
        ))}
      </div>
    </article>
  );
};

export default AdminCrewReportImportEmailGroup;
